import React, { useCallback, useMemo } from "react";
import { Button, Form, Input, Layout, Popover } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAppContext, useDashboardPanelContext } from "@data-root/react";

const { Content } = Layout;

export const AddParamButton = () => {
  const { getView } = useAppContext();
  const { layout, setParam } = useDashboardPanelContext();

  const { tableId } = useMemo(
    () => getView(layout.viewId),
    [layout.viewId, getView]
  );

  const onFinish = useCallback(
    ({ paramId, value }: { paramId: string; value: string }) => {
      setParam(tableId, paramId, value, value);
    },
    [setParam, tableId]
  );

  return (
    <Popover
      content={
        <Layout>
          <Content>
            <Form layout="vertical" name="New Param" onFinish={onFinish}>
              <Form.Item label="Param ID" name="paramId" required>
                <Input placeholder="Param" />
              </Form.Item>

              <Form.Item label="Value" name="value" required>
                <Input placeholder="Value" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<PlusOutlined />}
                >
                  Add
                </Button>
              </Form.Item>
            </Form>
          </Content>
        </Layout>
      }
    >
      <Button
        style={{ color: "black" }}
        type="link"
        size="small"
        icon={<PlusOutlined />}
      />
    </Popover>
  );
};
